import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import MainHeading from "../../../components/comman/MainHeading";

export default function PaymentAdvisoryDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [paymentAdvisoryData, setPaymentAdvisoryData] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    GetPaymentAdvisoryDetail();
  }, []);

  const GetPaymentAdvisoryDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_voucher_details + `?voucherId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setPaymentAdvisoryData(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid">
        <MainHeading title="Payment Advisory Detail" showBackButton={true} />
        <div className="card manage-user-list">
          <div className="card-body">
            <ul
              className={
                isLoading
                  ? "row list-unstyled mt-4 loading-skeleton"
                  : "row list-unstyled mt-4"
              }
            >
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Payment Advisory No. :-
                  </span>
                  {paymentAdvisoryData?.voucherNumber || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">{paymentAdvisoryData?.paymentticket?.ticketNumber ? "PT No." : "ST No."} :-</span>
                  {paymentAdvisoryData?.paymentticket?.ticketNumber || paymentAdvisoryData?.salaryticket?.ticketNumber || "--"}
                </p>
              </li>
              {paymentAdvisoryData?.paymentticket?.type &&
                <li className="col-12 col-md-6 col-lg-3">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Type :-
                    </span>
                    <span
                      className={
                        paymentAdvisoryData?.paymentticket?.type === "AgainstPO"
                          ? "badge bg-blue-25 fw-normal rounded-pill"
                          : paymentAdvisoryData?.paymentticket?.type === "General"
                            ? "badge bg-grey-25 fw-normal rounded-pill"
                            : "badge bg-brown-25 fw-normal rounded-pill"
                      }
                    >
                      {paymentAdvisoryData?.paymentticket?.type === "AgainstPO"
                        ? "Against PO"
                        : paymentAdvisoryData?.paymentticket?.type === "General"
                          ? "General"
                          : "Miscellaneous"}
                    </span>
                  </p>
                </li>}
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Site :-</span>
                  {paymentAdvisoryData?.paymentticket?.site?.name || paymentAdvisoryData?.salaryticket?.site?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Payment Method :-
                  </span>
                  {paymentAdvisoryData?.Transactions?.[0]?.paymentMethod || "--"}
                </p>
              </li>
              {paymentAdvisoryData?.paymentMethod === "Cash" && (
                <li className="col-12 col-md-6 col-lg-3">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Reference Name :-
                    </span>
                    {paymentAdvisoryData?.referenceName || "--"}
                  </p>
                </li>
              )}

              {(paymentAdvisoryData?.Transactions?.[0]?.paymentMethod === "NEFT" ||
                paymentAdvisoryData?.Transactions?.[0]?.paymentMethod === "RTGS" ||
                paymentAdvisoryData?.Transactions?.[0]?.paymentMethod === "IMPS") &&
                <>
                  <li className="col-12 col-md-6 col-lg-3">
                    <p>
                      <span className="text-muted fs-5 d-block">
                        Bank Name :-
                      </span>
                      {paymentAdvisoryData?.Transactions?.[0]?.bankName || "--"}
                    </p>
                  </li>
                  <li className="col-12 col-md-6 col-lg-3">
                    <p>
                      <span className="text-muted fs-5 d-block">
                        Account Holder Name :-
                      </span>
                      {paymentAdvisoryData?.Transactions?.[0]?.accountHolderName || "--"}
                    </p>
                  </li>
                  <li className="col-12 col-md-6 col-lg-3">
                    <p>
                      <span className="text-muted fs-5 d-block">
                        Account Number :-
                      </span>
                      {paymentAdvisoryData?.Transactions?.[0]?.accountNumber || "--"}
                    </p>
                  </li>
                </>
              }

              {paymentAdvisoryData?.Transactions?.[0]?.paymentMethod !== "Cash" && (
                <li className="col-12 col-md-6 col-lg-3">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      UTR Number :-
                    </span>
                    {paymentAdvisoryData?.Transactions?.[0]?.utr || "--"}
                  </p>
                </li>
              )}

              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Transaction Date :-
                  </span>
                  {moment(paymentAdvisoryData?.transactionDate).format("DD-MM-YYYY") ||
                    "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Amount :-</span>
                  {formatAmount(paymentAdvisoryData?.Transactions?.[0]?.amount) || "--"}
                </p>
              </li>

              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">Created By :-</span>
                  {paymentAdvisoryData?.Transactions?.[0]?.user?.name || "--"}
                </p>
              </li>
              <li className="col-12">
                <p>
                  <span className="text-muted fs-5 d-block">Remark :-</span>
                  {paymentAdvisoryData?.remark || "--"}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">Payment References</h4>
              </div>
              <ul className="row list-unstyled gap-3">
                {paymentAdvisoryData?.documents?.length > 0 ? (
                  paymentAdvisoryData?.documents?.map((doc, index) => {
                    return (
                      <li key={index} className="col-12">
                        <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <div>No Payment References Found</div>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
